import AntTooltip, {
  TooltipPropsWithOverlay,
  TooltipPropsWithTitle,
} from 'antd/lib/tooltip';
import React from 'react';

interface ITooltipPropsWithOverlay extends TooltipPropsWithOverlay {}
interface ITooltipPropsWithTitle extends TooltipPropsWithTitle {}

export type TTooltipProps = ITooltipPropsWithOverlay | ITooltipPropsWithTitle;

/**
 * Tooltip component
 */
export const Tooltip: React.FC<TTooltipProps> = (props) => (
  <AntTooltip {...props} />
);
